<template>
<div>
    <pt-branch-company-form ref="form" class="pt-branch-company-form__withData" :BranchCompanyDetail="BranchCompanyDetail" :isEdit="isEdit" :Business="Business" :addressList="areaList"></pt-branch-company-form>
</div>
</template>

<script>
import PtBranchCompanyForm from './form'
export default {
  name: 'pt-branch-company-form__withData',
  components: {
    'pt-branch-company-form': PtBranchCompanyForm
  },
  computed: {
    form () {
      return this.$refs.form
    }
  },
  props: {
    isEdit: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      BranchCompanyDetail: {},
      formValue: {},
      Business: [],
      areaList: []
    }
  },
  methods: {
    getAreatList () {
      this.$store.dispatch('getBusinessArea').then(data => {
        let options = []
        data.forEach(item => {
          let signalItem = {
            label: item.name,
            value: item.value
          }
          options.push(signalItem)
        })
        this.areaList = options
      })
    },
    getBrachBusinessType () {
      this.$store.dispatch('getBrachBusinessType').then(res => {
        this.Business = res
      }).catch(err => {
        this.$message.error(err || '获取用户详情失败')
      })
    },
    getBranchCompanyDetail () {
      this.$emit('detailLoading', true)
      this.$store.dispatch('getBranchCompanyDetail', this.$route.params.id).then(res => {
        this.$emit('detailLoading', false)
        this.BranchCompanyDetail = res
      }).catch(err => {
        this.$emit('detailLoading', false)
        this.$message.error(err || '获取用户详情失败')
      })
    },
    submit () {
      this.form.validate().then(formValue => {
        if (!this.isEdit) {
          this.createBranchCompany(formValue)
        } else {
          this.updateBranchCompany(formValue)
        }
      })
    },
    createBranchCompany (data) {
      this.$emit('submitLoading', true)
      this.$store.dispatch('createBranchCompany', data).then(res => {
        this.$emit('submitLoading', false)
        this.$message.success('新建分/子公司成功')
        history.go(-1)
      }).catch(errorMessage => {
        this.$emit('submitLoading', false)
        this.$message.error(errorMessage || '新建分/子公司失败')
      })
    },
    updateBranchCompany (data) {
      this.$emit('submitLoading', true)
      this.$store.dispatch('updateBranchCompany', data).then(res => {
        this.$emit('submitLoading', false)
        this.$message.success('编辑分/子公司成功')
        history.go(-1)
      }).catch(err => {
        this.$emit('submitLoading', false)
        this.$message.error(err || '编辑分/子公司失败')
      })
    }
  },
  created () {
    this.getAreatList()
    this.getBrachBusinessType()
    if (this.isEdit) {
      this.getBranchCompanyDetail()
    }
  }
}
</script>
